import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { RouteProps } from 'react-router-dom';
import Input from '../../../components/input/input';
import DataStore from '../../store/DataStore';
import messages from '../messages';
import classNames from 'classnames';
interface IDataStore {
  dataStore?: DataStore;
}

interface IAge {
  onForceNext?: () => void;
}

const Age: React.SFC<RouteProps & IDataStore & IAge & InjectedIntlProps> = ({
  dataStore,
  intl,
  onForceNext
}) => {
  const onKeyDown = event => {
    if (event.which == 13 || event.keyCode == 13) {
      if (typeof onForceNext === 'function') onForceNext();
    }
  };
  return (
    <div className={classNames('c-bubble__content')}>
      <FormattedMessage {...messages.age} />
      <Input
        onKeyDown={event => onKeyDown(event)}
        onChange={event => {
          dataStore.setAge(event.currentTarget.value);
        }}
        value={dataStore.age ? String(dataStore.age) : ''}
        label={intl.formatMessage(messages.ageLabel)}
      />
    </div>
  );
};

export default inject('dataStore')(injectIntl(observer(Age)));



// WEBPACK FOOTER //
// ./src/containers/fitting/components/Age.tsx